import Image from 'next/image';
import { CSSProperties } from 'react';

import SmartChangeLogo from '@assets/logo-smart-change.svg';

interface SmartChangeIconProps {
    height?: number;
    style?: CSSProperties;
    className?: string;
}

export function SmartChangeIcon({ height = 36, ...props }: Readonly<SmartChangeIconProps>) {
    const image = SmartChangeLogo;

    return <Image height={height} blurDataURL={image} src={image} alt='Smart Change' priority {...props} />;
}
